export default "__VITE_ASSET__09ac49ff__"